import { cn } from "@aichat/ui/lib/utils";

const MessengerIcon = ({
  className,
  filled,
}: {
  className?: string;
  filled?: boolean;
}) => {
  if (filled)
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M12 24.0547C18.6274 24.0547 24 18.6821 24 12.0547C24 5.42727 18.6274 0.0546875 12 0.0546875C5.37258 0.0546875 0 5.42727 0 12.0547C0 18.6821 5.37258 24.0547 12 24.0547Z"
          fill="#0082FF"
        />
        <path
          d="M11.9994 5.73828C8.51149 5.73828 5.68359 8.35933 5.68359 11.593C5.69039 12.4853 5.90686 13.3634 6.31553 14.1567C6.7242 14.9499 7.31362 15.6359 8.03623 16.1593L8.06149 18.223C8.06199 18.2485 8.06909 18.2734 8.08211 18.2952C8.09513 18.3171 8.11361 18.3352 8.13575 18.3478C8.15788 18.3604 8.1829 18.367 8.20836 18.367C8.23382 18.367 8.25884 18.3604 8.28096 18.3478L10.2531 17.2283C10.8229 17.379 11.41 17.4544 11.9994 17.4525C15.4873 17.4525 18.3152 14.8314 18.3152 11.5978C18.3152 8.36407 15.4873 5.73828 11.9994 5.73828ZM12.4731 13.4751L11.1231 12.0699C11.0843 12.0299 11.0336 12.0036 10.9786 11.9951C10.9236 11.9865 10.8674 11.9962 10.8183 12.0225L8.44991 13.2983C8.43098 13.3072 8.40955 13.3094 8.38919 13.3045C8.36884 13.2996 8.35078 13.2879 8.33804 13.2712C8.3253 13.2546 8.31864 13.2341 8.31917 13.2132C8.3197 13.1923 8.32739 13.1721 8.34096 13.1562L11.1468 10.1988C11.1657 10.1786 11.1885 10.1625 11.2139 10.1514C11.2393 10.1404 11.2667 10.1347 11.2944 10.1347C11.3221 10.1347 11.3495 10.1404 11.3749 10.1514C11.4002 10.1625 11.4231 10.1786 11.442 10.1988L12.7889 11.6309C12.8274 11.6717 12.8783 11.6987 12.9337 11.7075C12.9891 11.7164 13.0459 11.7067 13.0952 11.6799L15.4241 10.4167C15.4431 10.405 15.4657 10.4008 15.4876 10.4048C15.5095 10.4089 15.5292 10.4209 15.5427 10.4386C15.5563 10.4563 15.5628 10.4783 15.561 10.5006C15.5592 10.5228 15.5493 10.5435 15.5331 10.5588L12.7731 13.483C12.7542 13.5041 12.7312 13.521 12.7054 13.5326C12.6796 13.5442 12.6517 13.5503 12.6234 13.5505C12.5951 13.5506 12.5672 13.5448 12.5413 13.5335C12.5154 13.5221 12.4921 13.5055 12.4731 13.4846V13.4751Z"
          fill="white"
        />
      </svg>
    );

  return (
    <svg
      className={cn(["w-5 h-5", className])}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.2002C0 4.62676 4.40662 0.5 10.0926 0.5C15.7786 0.5 20.1852 4.62676 20.1852 10.2002C20.1852 15.7736 15.7786 19.9004 10.0926 19.9004C9.07115 19.9004 8.09032 19.7676 7.17041 19.5161C6.99171 19.4678 6.80285 19.4819 6.63228 19.5563L4.63 20.4316C4.10608 20.659 3.51515 20.2907 3.49687 19.7233L3.44204 17.9447C3.43392 17.7254 3.33441 17.5221 3.16993 17.3753C1.20624 15.6348 0 13.1157 0 10.2002ZM6.99778 8.37726L4.03295 13.0372C3.74663 13.4839 4.30304 13.9889 4.72745 13.669L7.91363 11.2726C8.12888 11.1117 8.42536 11.1097 8.64265 11.2706L11.0003 13.0231C11.707 13.5483 12.7183 13.3632 13.1894 12.6227L16.1522 7.96479C16.4385 7.51811 15.8821 7.01308 15.4577 7.333L12.2735 9.72737C12.0583 9.88833 11.7618 9.89034 11.5445 9.72938L9.18688 7.97686C8.48019 7.45171 7.4689 7.63682 6.99778 8.37726Z"
        fill="url(#paint0_linear_340_31754)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_340_31754"
          x1="-0.000126932"
          y1="0.5"
          x2="-0.000126932"
          y2="20.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00B2FF" />
          <stop offset="1" stopColor="#006AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MessengerIcon;
